export default "__VITE_ASSET__729b9c82__"